import * as zod from 'zod';

import { formatAmount } from '~/shared/lib/formatAmount';
import { MonetaryAmount } from '~/shared/types';

import { useLocalization } from '../../localization/localization';
import {
  MAX_AMOUNT,
  MAX_CHARACTERS,
  MIN_AMOUNT,
  MIN_CHARACTERS,
} from '../../utils/constants/defaultValues';

export const useSteamSchema = () => {
  const { t } = useLocalization();

  const steamSchemaAmount = zod.coerce
    .number({ invalid_type_error: t('Invalid amount') })
    .min(MIN_AMOUNT, {
      message: t('Amount min max', {
        maxAmount: formatAmount({ amount: MAX_AMOUNT as MonetaryAmount }),
        minAmount: formatAmount({ amount: MIN_AMOUNT as MonetaryAmount }),
      }),
    })
    .max(MAX_AMOUNT, {
      message: t('Amount min max', {
        maxAmount: formatAmount({ amount: MAX_AMOUNT as MonetaryAmount }),
        minAmount: formatAmount({ amount: MIN_AMOUNT as MonetaryAmount }),
      }),
    });

  const steamDataSchema = zod.object({
    amount: steamSchemaAmount,
    login: zod
      .string()
      .min(MIN_CHARACTERS, { message: t('Login required') })
      .max(MAX_CHARACTERS, { message: t('No more than twenty characters') })
      .regex(/^[A-Za-z0-9_]+$/, {
        message: t('Only latin letters numbers and the underline'),
      }),
  });

  return { steamSchemaAmount, steamDataSchema };
};
